import * as FaIcons from "react-icons/fa6";

const Footer = () => {
  return (
    <footer id="contact" className="footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 mb-4">
                    <h5>Contact Information</h5>
                    <a href='mailto:conference@cvs.du.ac.in'><i className="fas fa-envelope me-2"></i>conference@cvs.du.ac.in</a>
                    <a href="https://www.cvs.edu.in/" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-globe me-2"></i>Visit CVS Website
                    </a>
                    <div className="socials">
                    <a href="https://linkedin.com/company/aisymposium" target="_blank" rel="noopener noreferrer">
                        <FaIcons.FaLinkedin className="me-2"/>
                    </a>
                    <a href="https://www.facebook.com/aisymposiumdu" target="_blank" rel="noopener noreferrer">
                        <FaIcons.FaFacebook className="me-2"/>
                    </a>
                    <a href="https://www.instagram.com/aisymposiumdu" target="_blank" rel="noopener noreferrer">
                        <FaIcons.FaInstagram className="me-2"/>
                    </a>
                    <a href="https://x.com/aisymposiumdu" target="_blank" rel="noopener noreferrer">
                        <FaIcons.FaXTwitter className="me-2"/>
                    </a>
                    </div>
                </div>
                <div className="col-lg-3 mb-4">
                    <h5>Quick Links</h5>
                    <a href="#timeline"><i className="fas fa-calendar me-2"></i>Important Dates</a>
                    <a href="#topics"><i className="fas fa-lightbulb me-2"></i>Conference Topics</a>
                    <a href="https://www.cvs.edu.in/uploads/pdf/1751538319_44433_(1).pdf" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-download me-2"></i>Download Poster
                    </a>
                    <a href="https://forms.gle/yT87PXVkMQ4E3qRk7" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-user-plus me-2"></i>Register as Participant
                    </a>
                </div>
                <div className="col-lg-3 mb-4">
                    <h5>Documents</h5>
                    {/* <a href="https://drive.google.com/file/d/1XQNubVz0b_dWBRqzpPx8PBnihdfyca-H/view?usp=sharing" target="_blank" rel="noopener noreferrer"> */}
                    <a href="/description-of-review-process.pdf" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-file-alt me-2"></i>Description of Review Process
                    </a>
                    <a href="/policy-paper.pdf" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-file-alt me-2"></i>Policy Paper
                    </a>
                    <a href="/Ethics_Malpractice_Policy.pdf" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-file-alt me-2"></i>Ethics & Malpractice Policy
                    </a>
                    <a href="/call-for-papers-2025.pdf" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-file-alt me-2"></i>Call for Papers
                    </a>
                </div>
                <div className="col-lg-3 mb-4">
                    <h5>Organizers</h5>
                    <p><i className="fas fa-graduation-cap me-2"></i>College of Vocational Studies</p>
                    <p><i className="fas fa-building me-2"></i>University of Delhi</p>
                </div>
            </div>
            <hr className="my-4" style={{ borderColor: 'rgba(0, 212, 255, 0.3)' }} />
            <div className="row align-items-center text-center">
                <div className="col-lg-8 text-lg-start">
                    <p className='p-0'>&copy; 2025 College of Vocational Studies, University of Delhi. All rights reserved.</p>
                </div>
                <div className="col-lg-4 text-lg-end">
                    <a href="https://breydigital.com" className='p-0' target="_blank" rel="noopener noreferrer">
                        <p className="loading-text p-0">
                            {/* <i className="fas fa-code"></i> */}
                            Powered by Brey Digital
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </footer>
  );
};

export default Footer;